export type MLogoContainerColor = 'branded' | 'color' | 'grey' | 'white' | 'background-aware' | 'alternate-logo';

export interface MLogoContainerBaseProps {
  brand: string;
  backgroundColor?: string;
  color?: MLogoContainerColor;
  aspectRatio: string;
  width: number;
  height: number;
  alignment?: 'Bottom Left' | 'Center Left' | 'Bottom Centered' | 'Centered';
  hoverColor?: string;
  ariaRole?: string;
  logopath?: string;
  aspectMode?: string;
  brandFullName?: string;
}

export interface MLogoContainerAsLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  isLink: true;
  linkUrl: string;
}

export interface MLogoContainerAsSpanProps extends React.HTMLAttributes<HTMLSpanElement> {
  isLink?: false | undefined;
  linkUrl?: undefined;
}

export type MLogoContainerProps = (MLogoContainerAsSpanProps | MLogoContainerAsLinkProps) & MLogoContainerBaseProps;

export enum MLogoContainerBrand {
  MI = 'brand-logo-MI',
  MBS = 't-program-logo-color-s',
  JW = 'brand-logo-JW',
  RZ = 'brand-logo-rz',
}

export enum MLogoContainerSize {
  S = 's',
  M = 'm',
  L = 'l',
}
